<!-- Entry form -->
@if (!isAccountValidated) {
  <sp-form-wrapper [formGroup]="form">
    <div class="flex flex-column gap-3 pt-2">
      <div class="flex flex-column text-left w-full">
        <label htmlFor="mobileNumber" class="form-label required">
          <app-translate key="MOBILE_NUMBER_FIELD"></app-translate>
        </label>
        <div class="input-with-icon flex align-items-center border-round">
          <input type="text" id="mobileNumber" class="w-full skinny flex-1 border-none"
            (input)="formatPhone($event, 'mobileNumber')" placeholder="Enter phone number"
            maxlength="12" pInputText formControlName="mobileNumber" />
            @if (form.get('mobileNumber')?.value) {
              <button type="button" class="flex-shrink-0 p-1 border-none bg-transparent cursor-pointer text-color-secondary flex align-items-center justify-content-center"
                (click)="clearField('mobileNumber')">
                <i class="pi pi-times"></i>
              </button>
            }
          </div>
          <sp-control-error [parameters]="['Mobile Number']"
            [messagesParameters]="[{key: 'required', message: 'Enter a valid phone number.'}, {key: 'pattern', message: 'Enter a valid phone number.'}]"
          [control]="form.controls['mobileNumber']"></sp-control-error>
        </div>
        <div class="flex flex-column text-left w-full">
          <label htmlFor="fanNumber" class="form-label required flex align-items-center gap-1">
            <app-translate key="FAN_NUMBER_FIELD"></app-translate>
            <app-info-popover class="ml-auto fan-auth-info-popover" style="order: 1;" [header]="languageService.getTranslation('WHAT_IS_IT')"
              [isVisible]="showFanNumberInfo"
              (isVisibleChange)="onFanNumberInfoVisibilityChange($event)">
              {{ languageService.getTranslation('FAN_NUMBER_INFO_DESCRIPTION') }}
            </app-info-popover>
          </label>
          <div class="input-with-icon flex align-items-center border-round">
            <input type="text" id="fanNumber" class="w-full skinny flex-1 border-none" (keypress)="onlyNumbers($event)"
              placeholder="Enter FAN number" pInputText formControlName="fanNumber" />
              @if (form.get('fanNumber')?.value) {
                <button type="button" class="flex-shrink-0 p-1 border-none bg-transparent cursor-pointer text-color-secondary flex align-items-center justify-content-center"
                  (click)="clearField('fanNumber')">
                  <i class="pi pi-times"></i>
                </button>
              }
            </div>
            <sp-control-error [parameters]="['FAN Number']"
              [messagesParameters]="[{key: 'required', message: 'Enter a valid Fan Number.'}]"
            [control]="form.controls['fanNumber']"></sp-control-error>
          </div>
          <div class="flex flex-column text-left w-full">
            <label htmlFor="fanPin" class="form-label required flex align-items-center gap-1">
              <app-translate key="FAN_PIN_FIELD"></app-translate>
              <app-info-popover class="ml-auto fan-auth-info-popover" style="order: 1;" [header]="languageService.getTranslation('WHAT_IS_IT')"
                [isVisible]="showFanPinInfo"
                (isVisibleChange)="onFanPinInfoVisibilityChange($event)">
                {{ languageService.getTranslation('FAN_PIN_INFO_DESCRIPTION') }}
                <a href="https://business.att.com" target="_blank" rel="noopener noreferrer"
                class="text-primary">business.att.com</a>
              </app-info-popover>
            </label>
            <div class="input-with-icon flex align-items-center border-round">
              <input [type]="isFanPinMasked ? 'password' : 'text'" id="fanPin"
                class="w-full skinny flex-1 border-none" (keypress)="onlyNumbers($event)" placeholder="Enter PIN"
                pInputText formControlName="fanPin" />
                <button type="button" class="flex-shrink-0 p-1 border-none bg-transparent cursor-pointer text-color-secondary flex align-items-center justify-content-center"
                  (click)="toggleFanPinMask()">
                  <i class="pi" [ngClass]="isFanPinMasked ? 'pi-eye-slash' : 'pi-eye'"></i>
                </button>
              </div>
              <sp-control-error [parameters]="['FAN Pin']"
                [messagesParameters]="[{key: 'required', message: 'Enter a valid Fan Pin.'}]"
              [control]="form.controls['fanPin']"></sp-control-error>
            </div>
            @if (accountNotValidatedError) {
              <app-error-banner
                [title]="languageService.getTranslation('ACCOUNT_NOT_VALIDATED_TITLE')"
              [message]="languageService.getTranslation('ACCOUNT_NOT_VALIDATED_MESSAGE')"></app-error-banner>
            }
            <div class="flex justify-content-center">
              <p-button [styleClass]="'button-secondary validate-account-btn'"
                [label]="languageService.getTranslation('VALIDATE_ACCOUNT')"
              (click)="validateAccountClicked()" [outlined]="true"></p-button>
            </div>
          </div>
        </sp-form-wrapper>
      }

      <!-- Validated account summary -->
      @if (isAccountValidated) {
        <div class="account-details-card flex flex-column gap-2 pt-2 border-round">
          <div class="account-details-title text-center font-semibold text-sm">
            <app-translate key="ACCOUNT_DETAILS"></app-translate>
          </div>
          <div class="account-details-fields flex flex-column gap-2 border-round p-3">
            <div class="flex justify-content-between">
              <span class="text-sm text-color-secondary"><app-translate key="MOBILE_NUMBER_FIELD"></app-translate></span>
              <span class="text-sm font-medium">{{ validatedAccount?.mobileNumber }}</span>
            </div>
            <div class="flex justify-content-between">
              <span class="text-sm text-color-secondary"><app-translate key="FAN_NUMBER_FIELD"></app-translate></span>
              <span class="text-sm font-medium">{{ validatedAccount?.fanNumber }}</span>
            </div>
            <div class="flex justify-content-between">
              <span class="text-sm text-color-secondary"><app-translate key="FAN_PIN_FIELD"></app-translate></span>
              <span class="text-sm font-medium">{{ validatedAccount?.fanPin }}</span>
            </div>
          </div>
          <div class="pt-2 flex justify-content-center">
            <p-button icon="pi pi-trash" [styleClass]="'button-secondary clear-selection-btn'"
              [label]="languageService.getTranslation('CLEAR_SELECTION')"
            (click)="clearSelectionClicked()" [outlined]="true"></p-button>
          </div>
        </div>
      }